import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  prerequisitesContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: 'fit-content',
    gap: theme.spacing(3),
    marginTop: theme.spacing(1),
  },
  checkBoxText: {
    fontStyle: theme.typography.fontFamily,
    fontSize: '14px',
    color: theme.palette.labraText.tertiary,
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  choiceContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  inLineInfo: {
    display: 'flex',
    marginTop: theme.spacing(0.25),
    flexDirection: 'row',
    alignItems: 'center',
  },
}))
